import {FC} from 'react';
import {RecoilState, useSetRecoilState} from 'recoil';

import MuiChip, {ChipProps} from '@mui/material/Chip';

import {FilterType} from '../../../shared/types/filtersSet.types';

import styled from '@emotion/styled';
import {filterLabelMap} from '../constants/filters.data';
import {Stack, Typography} from '@mui/material';

interface IFilterItem {
  filterBy: string;
  value: string;
  deletable?: boolean;
  labelAsValue?: string | false;
  predefinedLabelAsValue?: string | false;
  handleDelete?: (filterBy: string) => void;
  filtersState: RecoilState<FilterType[]>;
}

const Chip = styled((props: ChipProps) => <MuiChip {...props} />)(() => ({
  backgroundColor: '#FFECCC',
  border: `1px solid #FF9F00`,
  '& .MuiChip-deleteIcon': {
    color: '#2196f3',
  },
  '& .MuiChip-deleteIcon:hover': {
    color: '#03a9f4',
  },
}));

export const FilterItem: FC<IFilterItem> = ({
  filterBy,
  value,
  deletable,
  handleDelete,
  filtersState,
  labelAsValue,
  predefinedLabelAsValue,
}) => {
  const setFilters = useSetRecoilState(filtersState);

  const deleteFilterItem = () => {
    setFilters((prev) => prev.filter((i) => i[0] !== filterBy));
  };

  return (
    <Chip
      variant="outlined"
      label={
        <Stack direction="row" spacing={0.5}>
          <Typography variant="subtitle2" sx={{color: '#818181'}}>
            {filterLabelMap.get(filterBy)}:
          </Typography>
          <Typography variant="subtitle2">{predefinedLabelAsValue || labelAsValue || value}</Typography>
        </Stack>
      }
      onDelete={deletable ? (handleDelete ? () => handleDelete(filterBy) : deleteFilterItem) : undefined}
    />
  );
};
